import clsx from 'clsx';
import { useMemo } from 'react';
import { useGlobalQueries } from '@/hooks/use-global-queries';
import { FooterBottom } from './components/footer-bottom';
import { FooterTop } from './components/footer-top';
import { Wave, WAVE_OVERLAP_VW } from './components/wave';
import { getTailwindColor } from '@/utils/colors';
import { SectionProps, sectionHasImageBackground } from '../section/section';

export const Footer = () => {
    const { pageQuery } = useGlobalQueries();

    const { bgClass, needsOverlap } = useMemo(() => {
        const blocks = pageQuery?.data?.blocks;
        const lastBlock = blocks?.[blocks.length - 1];
        const pageBgClass = getTailwindColor(pageQuery?.data?.page_background_color, 'bg');

        if (lastBlock?.blockName === 'next24hr/section') {
            const section = lastBlock as unknown as SectionProps;

            if (section.backgroundType === 'color' && typeof section.backgroundValue === 'string') {
                return { bgClass: getTailwindColor(section.backgroundValue, 'bg'), needsOverlap: false };
            }

            if (sectionHasImageBackground(section)) {
                return { bgClass: pageBgClass, needsOverlap: true };
            }
        }

        return { bgClass: pageBgClass, needsOverlap: false };
    }, [pageQuery?.data]);

    if (pageQuery?.data?.remove_footer) {
        return null;
    }

    return (
        <footer className={clsx(bgClass, 'r-relative r-z-10')} {...(needsOverlap && { style: { marginTop: `calc(-1 * ${WAVE_OVERLAP_VW})` } })}>
            <Wave />
            <div className="-r-mt-1 r-bg-tertiary-500 max-md:r-pt-10">
                <FooterTop />
                <FooterBottom />
            </div>
        </footer>
    );
};
